import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import { useAuthStore } from './stores/authStore'

// Verificar suporte a recursos
const checkBrowserSupport = () => {
  const features = {
    serviceWorker: 'serviceWorker' in navigator,
    indexedDB: 'indexedDB' in window,
    localStorage: 'localStorage' in window,
    online: navigator.onLine
  }
  
  console.log('Browser features:', features)
  
  // Armazenar para uso global
  window.$browserFeatures = features
  
  return features
}

// Inicializar app
const initApp = async () => {
  // Verificar suporte
  checkBrowserSupport()

  // Criar app Vue
  const app = createApp(App)
  const pinia = createPinia()

  // Usar plugins
  app.use(pinia)
  app.use(router)

  // Registrar propriedades globais
  app.config.globalProperties.$apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'
  app.config.globalProperties.$isOnline = () => navigator.onLine

  // Montar app
  app.mount('#app')
}

initApp().catch(console.error)
